import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './DivisionsSection.html?raw';
import topic from 'dojo/topic';
import on from 'dojo/on';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import "../../../moreCore/UI/_StatefulBase/_StatefulBase";
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import { AddressTypes } from "../../_loadingHelpers/Address";
import SelectBox from '../../../moreCore/UI/SelectBox/SelectBox';
import DivisionsEditForm from './DivisionsEditForm/DivisionsEditForm';
import AddressWizard from '../AddressWizard';
import { ToasterHelpers } from "../../../more/Helpers";

class DivisionsSection extends compose(_WidgetBaseSP) {
    templateString: any = template;

    constructor(addressId: string) {
        super(...(arguments as unknown as []));

        this.addressId = addressId;
    }

    private addressId: string;
    private tableContainer: HTMLElement;
    private table: MdsLax<InstanceType<typeof StaticTable>>;

    private entitylist: Array<any>;

    private tableLayout: StaticTable.RowConfig = {
        "attributes": ["name", "ref_vw_telecom_addresses.phonenumber", "ref_vw_telecom_addresses.mobilenumber", "ref_vw_telecom_addresses.emailaddress", "ref_address_sync_type.description"],
        colNamesInternal: ["name", "ref_vw_telecom_addresses.phonenumber", "ref_vw_telecom_addresses.mobilenumber", "ref_vw_telecom_addresses.emailaddress", "ref_address_sync_type.description", "Aktionen"],
        "colspans": [1, 1, 1],
        "headings": [(this as any).translations["General_Label_DivisionName"], (this as any).translations["AddressWizard__phone"], (this as any).translations["AddressWizard__MobileNumber"], (this as any).translations["AddressWizard__mail"], (this as any).translations["General_Label_SyncWith"], (this as any).translations["General_Label_Actions"]],
        widths: [null, "20ch", "20ch", "25ch", "15ch", "15ch"],
        alignmentsHeading: [null, null, null, null, null, "center"],
        alignmentsRow: [null, null, null, null, null, "center"]
    }

    private table_formatterFunction(cell: StaticTable.StaticTableCell<AddressTypes.Division>) {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;
        let rowIndex = cell.tableRow.rowGroup.rowIndex;

        let icon: HTMLElement;
        if (!cell.tableRow["fileSelect"]) cell.tableRow["fileSelect"] = new SelectBox();

        this.UiModder.domStyle.set(cell.tableCellNode, "vertical-align", "middle");

        switch (colName) {
            case "Aktionen":

                icon = this.createFontawesomeIcon("fas fa-list hoverTxtPrimary secondaryText w3-margin-right", "", node);
                this.UiModder.domAttr.set(icon, "title", this.translate("Divisions_ButtonTitle_ShowContactPersonList"));
                on(icon, "click", lang.hitch(this, this._showList, entity));
                if (!entity.EL_vt_contact_persons_division.length) this.UiModder.domClass.add(icon, "w3-disabled");

                icon = this.createFontawesomeIcon("fas fa-edit hoverTxtPrimary secondaryText w3-margin-right", "", node);
                this.UiModder.domAttr.set(icon, "title", this.translations["General_Edit"]);
                on(icon, "click", lang.hitch(this, this._editDivision, entity));

                icon = this.createFontawesomeIcon("fas fa-trash hoverTxtPrimary secondaryText warningTXT", "", node);
                this.UiModder.domAttr.set(icon, "title", this.translations["General_Delete"]);
                on(icon, "click", lang.hitch(this, this._onCLickDeleteDivision, entity.ID));

                return true;
                break;
        }

        return false;
    }

    private table_ContactPersonListFormatterFunction(cell: StaticTable.StaticTableCell<AddressTypes.ContactPersonEntity>) {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;
        let rowIndex = cell.tableRow.rowGroup.rowIndex;

        let icon: HTMLElement;

        switch (colName) {
            case "Aktionen":

                icon = this.createFontawesomeIcon("fas fa-edit hoverTxtPrimary secondaryText", "", node);
                this.UiModder.domAttr.set(icon, "title", this.translate("Divisions_ButtonTitle_ShowAddressWizard"));
                on(icon, "click", lang.hitch(this, this._callAddressWizzard, entity));

                return true;
                break;
        }

        return false;
    }
    private _emitHandle: any = null;

    private _callAddressWizzard(entity: AddressTypes.ContactPersonEntity): void {

        console.debug("ContactPerson ENTITY", entity);

        topic.publish("AddressWizard/OpenNewAddress", entity);
        this.emit("callAddressWizzard");
    }

    private _confirmCallback(dlg: MdsLax<InstanceType<typeof GenericDialog>>, form: MdsLax<InstanceType<typeof AddressWizard>>, result) {
        if (result <= 0) {
            dlg.close(-1, true);
        } else {
            form.submitFormData();
        }
    }

    private _showList(entity: AddressTypes.Division): void {

        let dlg = new GenericDialog();

        let table = new StaticTable();
        let layout: StaticTable.RowConfig = {
            "attributes": ["gDisp_1"],
            colNamesInternal: ["gDisp_1", "Aktionen"],
            "colspans": [1, 1],
            "headings": [this.translations["AddressWizard__ContactPerson"], this.translations["General_Label_Actions"]],
            widths: [null, "15ch"],
            alignmentsHeading: [null, "center"],
            alignmentsRow: [null, "center"]
        }

        table.addLineConfig(layout);
        table.setFormatter(lang.hitch(this, this.table_ContactPersonListFormatterFunction));
        table.setData(entity.EL_vt_contact_persons_division);
        table.setCyAttribute("divisionsSection");

        dlg.show(table,
            null/*this.translations["General_Label_ContactPersonList"]*/,
            null,
            null,
            "ok"
        );

        on(this, "callAddressWizzard", () => { dlg.close() });
    }

    private openEditForm(isNew: boolean, entity?: AddressTypes.Division): void {

        let form = new DivisionsEditForm();
        form.setupDivisionEditForm(isNew, entity, this.addressId);

        form.on("saved", lang.hitch(this, this.refreshDivisionsList))
    }

    private _editDivision(entity): void {

        this.openEditForm(false, entity);
    }

    private _onCLickDeleteDivision(entityId: string): void {

        let dlg = new GenericDialog();
        dlg.show(
            this.translations["General_ConfirmDeleteMessage"],
            null,
            this.translations["General_ConfirmDeleteSubtitle"],
            "fas fa-exclamation-triangle",
            "yesno",
            lang.hitch(this, this._deleteDivision, entityId)
        );
    }

    private _deleteDivision(entityId: string, response: number): void {
        if (response !== 2) return;

        this.StandbyStart();
        let requestUrl = window.appRoot + "AddressWizard/DeleteDivision";

        this.RequestManager.post(
            requestUrl, {
                id: entityId
            },
            lang.hitch(this, this._onDeleteDivisionResponse),
            lang.hitch(this, this._showErrorMessage),
            false // sync
        );
    }
    private _onDeleteDivisionResponse(response): void {
        this.StandbyStop();

        this.refreshDivisionsList();

        this.showToast({
            title: this.translate("General_DeletingSuccessful"),
            iconClass: ToasterHelpers.ToasterIcons.confirmCheck
        });
    }
    private drawTable(): void {

        this.tableContainer.innerHTML = null;
        if (this.table != null) this.table.destroy();

        this.table = new StaticTable();

        this.table.setFormatter(lang.hitch(this, this.table_formatterFunction));
        this.table.addLineConfig(this.tableLayout);
        this.table.setCyAttribute("divisionsSection");

        this.UiModder.domConstruct.place(this.table.domNode, this.tableContainer);

        //let list = this.entitylist.filter(x => x["state"] != "deleted");

        this.table.setData(this.entitylist);
    }

    private _onClick_AddDivision_Button(): void {

        this.openEditForm(true);
    }

    setup(data: Array<any>) {

        this.entitylist = data;

        this.tableContainer.innerHTML = null;

        if (this.entitylist.length) this.drawTable();
        else this.UiModder.domConstruct.create("p", { class: "italic", innerHTML: this.translations["General__NoEntries"] }, this.tableContainer);

        this.emit("SetupDivisionsList", this.entitylist.length !== 0);

        this.StandbyStop();
    }

    refreshDivisionsList(): void {

        this.getDivisionsList();
    }

    private getDivisionsList(): void {

        this.StandbyStart();
        let requestUrl = window.appRoot + "AddressWizard/GetDivisionsList";

        this.RequestManager.post(
            requestUrl,
            {
                id: this.addressId
            },
            lang.hitch(this, this.setup),
            lang.hitch(this, this._showErrorMessage),
            false // sync
        );
    }

    private _showErrorMessage(err: any) {

        alert(err.Message);
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.getDivisionsList();
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

    //    if (!this.hasFeature("Address/DivisionsSection", null, 2412090000)) {
    //        this.disableNode(this.domNode, !this.addressId);
    //        // erst ab dieser Version kann die Section mit lokalen Änderungen umgehen und ungespeicherte Adressen bearbeiten
    //    }
    }
}

export default mdsWidget(DivisionsSection);
